import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum FieldConfigReduxType {
    GET_FIELD_CONFIG = "@auth/GET_FIELD_CONFIG",
    GET_FIELD_CONFIG_SUCCESS = "@auth/GET_FIELD_CONFIG_SUCCESS",
    GET_FIELD_CONFIG_ERROR = "@auth/GET_FIELD_CONFIG_ERROR",
}

export type FieldConfigActionDispatch = {
    type:
    | FieldConfigReduxType.GET_FIELD_CONFIG
    payload: any;
}

export type FieldConfigReducerDispatch = {
    type:
    | FieldConfigReduxType.GET_FIELD_CONFIG
    | FieldConfigReduxType.GET_FIELD_CONFIG_SUCCESS
    | FieldConfigReduxType.GET_FIELD_CONFIG_ERROR

    payload: {
        data?: FetchApiResponse<FieldConfig>
        error?: string
    }
}

export type FieldConfig = {
    data: {
        [key: string]: Field
    };
}

export type Field = {
    changedFields: ChangedFields[],
    hiddenFields: string[]
}

export type ChangedFields = {
    fieldName: string;
    label: string;
    validationRegex: string,
    mandatory: boolean
}

export type FieldConfigReduxState = {
    loading?: boolean
    data?: CreateApiResponse<FieldConfig>
    error?: string | null;
}

export type FieldConfigFetchRequest = {
    payload: FilterMetadata;
    type: string;
}